import IconButton from "@mui/material/IconButton";
import type { MouseEvent } from "react";

interface DetachTabButtonProps {
  onClick: () => void;
}

export default function DetachTabButton({ onClick }: Readonly<DetachTabButtonProps>) {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      aria-label="Detach tab"
      sx={{ ml: 0.5, p: 0.25, fontSize: "0.875rem", opacity: 0.5, "&:hover": { opacity: 1 } }}
    >
      ⧉
    </IconButton>
  );
}
